import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { TEntityGridConstraints } from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { HotFixEntityGridReadRequest } from 'app/common/entity-grid/features/entity-grid';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { getReportsRequest } from '../../requests';
import { cols } from './reports-entity-grid-columns';

export const ReportsEntityGrid = observer(() => {
  const userRoles = useUserRoles();

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
    }),
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={getReportsRequest}
      userRoles={userRoles}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <HotFixEntityGridReadRequest />

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            autoSizeStrategy={{ type: 'fitGridWidth' }}
            rowSelection="multiple"
            persistSettingsId="TripsOrdersEntityGrid"
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
